import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import VModal from 'vue-js-modal';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  BSpinner,
  BPagination,
  BPopover,
  BFormGroup,
  BFormRadio,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BFormSelect,
  BFormSelectOption,
  BNav,
  BNavbar,
  BNavItem,
  BNavbarBrand,
  BNavbarToggle,
  BNavbarNav,
  BCollapse,
  VBToggle,
} from 'bootstrap-vue';
import YouTubePlayer from 'vue-youtube-embed';
import vSelect from 'vue-select';

import App from '@/web/App.vue';
import getRouter from '@/web/router';
import * as Common from '@/web/components/common';
import store from '@/core/store';
import { setAccessToken, setupResponseInterceptors } from '@/core/api';
import confirmModal from '@/web/directives/confirm-modal';
import '@/web/utils/fonts';
import FirebasePlugin from '@/web/services/firebase-plugin';
import {
  formatCurrency,
  setLocal,
  formatNumber,
  formatDate,
  formatBytes,
} from '@/web/utils/format';
import {
  SET_ACCESS_TOKEN,
  SET_TEACHER,
  SET_CURRENCY,
  EVENT_STARTING_SOON,
  EVENT_UPDATED,
  SET_EVENT_STARTING_SOON,
  SET_TRANSLATIONS,
  SET_USER_INFO_PROMISE,
  SET_NOTIFICATIONS_TOKEN,
  SET_STUDIO_NOTIFICATIONS_TOKEN,
} from '@/core/store/mutation-types';
import * as angularHelper from '@/web/utils/angular-helper';
import * as analytics from '@/web/services/analytics';

import 'vue-select/dist/vue-select.css';
import 'vue-swatches/dist/vue-swatches.css';
import './web/styles/hey-marvelous-bootstrap.scss';
import VueClipboard from 'vue-clipboard2';
import LoadScript from 'vue-plugin-load-script';
import VTooltip from 'v-tooltip';
import VueTheMask from 'vue-the-mask';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import VCalendar from 'v-calendar';
import VueNativeSock from 'vue-native-websocket';
import VueMeta from 'vue-meta';
import Rollbar from 'rollbar';
import i18n from '@/web/utils/localization';
import { getAvatarURL, hasOwn } from '@/core/utils/utils';
import * as types from '@/core/store/mutation-types';
import { hotjarIdentify } from '@/web/services/hotjar';
import { Intercom } from '@mathieustan/vue-intercom';
import { initCanvaButtonApi } from './web/services/canva';
import Editor from 'vue-editor-js/src/index';
import userflow from 'userflow.js';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { installVueDynamicHeight } from 'vue-dynamic-height';
import VueCookie from 'vue-cookie';
import {
  subscribeStudioToCommunityNotifications,
  subscribeToCommunityNotifications,
  connectChatUser,
} from '@/core/services/stream';
import infiniteScroll from 'vue-infinite-scroll';
import responseInterceptors from '@/core/api/utils/response-interceptors';
import moment from 'moment';
import 'moment/min/locales.min';
import { getNavigatorLanguage } from '@/web/utils/languages';
import HMToast from '@/web/components/common/HMToast.vue';
import ToggleButton from 'vue-js-toggle-button';
import Toast from 'vue-toastification';
import { notificationToToast } from '@/web/utils/notify';
import { setDeferedAddToHomescreen } from '@/web/utils/detect-device';
import vueE164 from 'vue-e164';
import VueImg from 'v-img';
import VueSignaturePad from 'vue-signature-pad';

// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['zapier-full-experience'];

if (process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN) {
  Vue.prototype.$rollbar = new Rollbar({
    accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
    environment: process.env.NODE_ENV,
    captureUncaught: true,
    captureUnhandledRejections: true,
  });

  Vue.config.errorHandler = (err, vm, info) => {
    // @ts-ignore
    vm.$rollbar.error(err);
    throw err; // rethrow
  };
}

Object.keys(Common).forEach(key => {
  Vue.component(key, Common[key]);
});

Vue.prototype.$formatCurrency = formatCurrency;
Vue.prototype.$formatNumber = formatNumber;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$formatBytes = formatBytes;
Vue.prototype.$track = analytics.track;
Vue.prototype.$trackOnPage = function (eventName, data = {} as any) {
  data.page_name = this.$route.name;
  analytics.track(eventName, data);
};

//plugins
Vue.use(VModal, {
  dynamicDefaults: {
    height: 'auto',
    scrollable: true,
    shiftY: 0.3,
  },
});
Vue.use(Editor);
Vue.use(YouTubePlayer);
Vue.use(VueClipboard);
Vue.use(FirebasePlugin);
Vue.use(LoadScript);
Vue.use(VTooltip);
Vue.use(VueTheMask);
Vue.use(VueAwesomeSwiper);
Vue.use(VueMeta);
Vue.use(installVueDynamicHeight);
Vue.use(VueCookie);
Vue.use(infiniteScroll);
Vue.use(VCalendar);
Vue.use(ToggleButton);
Vue.use(Toast);
Vue.use(vueE164, {
  plus: true,
  brackets: false,
  space: false,
  dash: false,
  areaCode: true,
});
Vue.use(VueImg);
Vue.use(VueSignaturePad);

const intercom = new Intercom({ appId: process.env.VUE_APP_INTERCOM_APP_ID });
// setup Websocket
Vue.use(VueNativeSock, process.env.VUE_APP_WEBSOCKET_URL, {
  store: store,
  format: 'json',
  reconnection: process.env.NODE_ENV != 'development',
  passToStoreHandler: function (eventName, event) {
    if (!eventName.startsWith('SOCKET_')) {
      return;
    }
    const namespace = 'websocket';
    let method = 'commit';
    let target = eventName.toUpperCase();
    let msg = event;
    if (this.format === 'json' && event.data) {
      msg = JSON.parse(event.data);
      msg.action = 'eventReceived';
      msg.namespace = namespace;
      if (msg.mutation) {
        target = [msg.namespace || '', msg.mutation].filter(e => !!e).join('/');
      } else if (msg.action) {
        method = 'dispatch';
        target = [msg.namespace || '', msg.action].filter(e => !!e).join('/');
      }
    } else {
      target = [namespace || '', target].filter(e => !!e).join('/');
    }
    this.store[method](target, msg);
  },
});

window.addEventListener('beforeinstallprompt', setDeferedAddToHomescreen);

//components
Vue.component('b-spinner', BSpinner);
Vue.component('b-pagination', BPagination);
Vue.component('b-popover', BPopover);
Vue.component('b-form-datepicker', BFormDatepicker);
Vue.component('b-form-timepicker', BFormTimepicker);
Vue.component('b-form-select', BFormSelect);
Vue.component('b-form-select-option', BFormSelectOption);
Vue.component('b-nav', BNav);
Vue.component('b-navbar', BNavbar);
Vue.component('b-nav-item', BNavItem);
Vue.component('b-navbar-brand', BNavbarBrand);
Vue.component('b-navbar-toggle', BNavbarToggle);
Vue.component('b-navbar-nav', BNavbarNav);
Vue.component('b-collapse', BCollapse);
Vue.component('b-form-group', BFormGroup);
Vue.component('b-form-radio', BFormRadio);
Vue.component('b-form-radio-group', BFormRadioGroup);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('v-select', vSelect);
Vue.component('vue-slider', VueSlider);

//directives
Vue.directive('confirm', confirmModal);
Vue.directive('b-toggle', VBToggle);

Vue.prototype.$notify = function (data) {
  const { content, config } = notificationToToast(data);
  Vue.$toast(content, config);
};

// Copy and then delete AngularJs token
const angularAccessToken = angularHelper.getAccessToken();
if (angularAccessToken) {
  store.commit(`user/${types.SET_ACCESS_TOKEN}`, angularAccessToken);
  angularHelper.clearAccessToken();
}

// Copy and then delete AngularJs Studio Password
const angularStudioPassword = angularHelper.getStudioPassword();
if (angularStudioPassword) {
  store.commit(
    `user/${types.SET_LOCAL_STUDIO_PASSWORD}`,
    angularStudioPassword
  );
  angularHelper.clearStudioPassword();
}

function onAccessToken(accessToken) {
  // set API header token
  setAccessToken(accessToken);
  // update user data
  const loadUserInfoPromise = store.state.user.userInfoPromise;
  if (!loadUserInfoPromise) store.dispatch('user/loadUserInfo');

  if (!accessToken && window.Marvelous) {
    window.Marvelous.User = {};
  }
}

function onEventStartingSoon(payload) {
  if (payload.student_id === store.getters['user/studentId']) {
    // don't display multiple dialogs if dialog is still open
    if (!store.getters['studio/eventStartingSoon']) {
      store.commit(`studio/${SET_EVENT_STARTING_SOON}`, payload);
    }
  }
}

function onEventUpdated(payload) {
  const currentEvent = store.getters['event/event'];
  if (payload.event_id === currentEvent?.id) {
    try {
      store.dispatch('event/getStudioEventDetails', {
        studioURL: currentEvent.shop_url,
        eventId: currentEvent.id,
      });
    } catch (error) {
      // ignore, it's most likely past event
    }
  }
}

function loadTranslations(studioUrl) {
  if (studioUrl) {
    store.dispatch('studio/loadTranslations', studioUrl);
  }
}

function onTranslationsLoaded(payload) {
  // merge static and dynamically loaded translations
  const translations = payload?.translations || [];
  for (const locale in translations) {
    if (hasOwn(payload.translations, locale)) {
      i18n.mergeLocaleMessage(locale, payload.translations[locale]);
    }
  }
  moment.locale(getNavigatorLanguage());
}

function updateLocal() {
  const language = store.getters[`user/language`];
  const currency = store.getters[`user/currency`];
  setLocal(language, currency);
}

function rebootIntercom(intercomBootPayload) {
  intercom.shutdown();

  if (intercom.isBooted) return;
  intercom.boot(intercomBootPayload);
  intercom.update({ hide_default_launcher: false });
}

function startIntercomMessenger(intercomBootPayload) {
  if (!intercom.ready) {
    intercom.once('ready', () => rebootIntercom(intercomBootPayload));
  } else {
    rebootIntercom(intercomBootPayload);
  }
}

function startUserflow(userId, userflowPayload) {
  // @ts-ignore
  userflow.init(process.env.VUE_APP_USERFLOW_TOKEN);
  userflow.identify(userId, userflowPayload);
}

async function postUserInfoLoadedHandler(promise) {
  if (!promise) return;
  const userInfo = await promise;
  const { role, student, teacher } = userInfo;
  const studioURL = store.getters['studio/currentStudioUrl'];
  const userId = store.getters['user/userId'];
  const userHash = store.getters['user/userHash'];
  const user = store.getters['user/user'];
  hotjarIdentify(studioURL, userId, role);

  const intercomBootPayload = {
    user_id: userId,
    name: user.user_full_name,
    email: user.user_email,
    user_hash: userHash,
  };
  window.Marvelous = window.Marvelous || {};
  window.Marvelous.User = { ...intercomBootPayload };

  if (role === 'teacher' && !store.getters['globals/isPWA']) {
    startIntercomMessenger(intercomBootPayload);

    const userflowPayload = {
      name: user.user_full_name,
      email: user.user_email,
      signed_up_at: teacher.date_joined,
      plan_name: teacher?.teacher?.subscription_plan?.plan_name,
    };
    startUserflow(userId, userflowPayload);
  }
  // connect student user for chat notifications
  const communityProfile = await store.dispatch(
    'community/loadStudentCommunityProfileData'
  );
  if (communityProfile.chat_token) {
    const id = user.community_profile_id;
    const name = user.community_last_name
      ? `${user.community_first_name} ${user.community_last_name}`
      : user.community_first_name;
    const image = user.community_profile_photo;
    connectChatUser(id, name, image, communityProfile.chat_token);
  }
}

function onCommunityNotificationsTokenLoaded(token, communityProfileId) {
  subscribeToCommunityNotifications(token, communityProfileId, data => {
    console.log('Student community notification: ', data);
    store.dispatch('community/processNotificationsCallback', data);
  });
  store.dispatch('community/loadNotifications', {
    markSeen: false,
  });
}

function onCommunityNotificationsStudioTokenLoaded(token, communityProfileId) {
  subscribeStudioToCommunityNotifications(token, communityProfileId, data => {
    console.log('Studio community notification: ', data);
    store.dispatch('community/processStudioNotificationsCallback', data);
  });
  store.dispatch('community/loadStudioNotifications', {
    markSeen: false,
  });
}

const withHttp = url =>
  url.replace(/^(?:(.*:)?\/\/)?(.*)/i, (match, schemma, nonSchemmaUrl) =>
    schemma ? match : `http://${nonSchemmaUrl}`
  );

function setupFilters() {
  Vue.filter('url', function (value) {
    if (!value) return '';
    return withHttp(value);
  });
}

store.subscribe(async ({ type, payload }) => {
  switch (type) {
    case `user/${SET_ACCESS_TOKEN}`:
      onAccessToken(payload);
      if (!payload) {
        analytics.logout();
        store.dispatch('globals/resetState');
        store.dispatch('community/disconnectChatClient');
      }
      break;
    case `user/${SET_CURRENCY}`:
      updateLocal();
      break;
    case `websocket/${EVENT_STARTING_SOON}`:
      onEventStartingSoon(payload);
      break;
    case `websocket/${EVENT_UPDATED}`:
      onEventUpdated(payload);
      break;
    case `studio/${SET_TRANSLATIONS}`:
      onTranslationsLoaded(payload);
      break;
    case `user/${SET_TEACHER}`:
      updateLocal();
      break;
    case `user/${SET_USER_INFO_PROMISE}`:
      postUserInfoLoadedHandler(payload);
      break;
    case `community/${SET_NOTIFICATIONS_TOKEN}`:
      await store.state.user.userInfoPromise;
      const studentCommunityProfileId =
        store.getters['user/studentCommunityProfileId'];
      onCommunityNotificationsTokenLoaded(payload, studentCommunityProfileId);
      break;
    case `community/${SET_STUDIO_NOTIFICATIONS_TOKEN}`:
      await store.state.user.userInfoPromise;
      const communityProfileId = store.getters['user/studioCommunityProfileId'];
      onCommunityNotificationsStudioTokenLoaded(payload, communityProfileId);
      break;
  }
});

onAccessToken(store.getters[`user/accessToken`]);
updateLocal();
initCanvaButtonApi(process.env.VUE_APP_CANVA_BUTTON_API_KEY);
analytics.init();
setupResponseInterceptors(responseInterceptors);
setupFilters();

async function startApp() {
  const router = await getRouter();

  new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
}

startApp();
